var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { locationTypeEntityName, missionLocationEntityName, missionPositionEntityName, missionTypeEntityName, } from '../../../../backend/config/classifiers';
import { requireAnySystemPermission } from '@juvare/contact-management/backend/features/permissions/shared';
import { occupationEntityName } from '@juvare/credentialing/backend/config/shared';
import { buildStorageValueProvider, buildValueProvider } from '@juvare/platform-sdk-react/ui/features/classifiers';
import { occupationsByGroupIdsParamsSchema } from '../types';
export function buildMissionsClassifierValueProviders(appName, userState) {
    return [
        buildValueProvider(appName, locationTypeEntityName, 'Location Type', false, locationTypeEntityName, (client) => {
            return client
                .storageList({
                filter: [{ column: 'status', op: '=', value: 'active' }],
            })
                .then((result) => result.rows.map((row) => ({ value: row.id, label: row.columns.name })));
        }),
        buildValueProvider(appName, missionLocationEntityName, 'Mission Location', false, missionLocationEntityName, (client) => {
            return client
                .storageList({
                filter: [{ column: 'status', op: '=', value: 'active' }],
                orderBy: [{ column: 'name' }],
            })
                .then((result) => {
                return result.rows.map((row) => ({
                    label: row.columns.name,
                    value: row.id,
                    description: row.columns.fullAddress,
                }));
            });
        }),
        buildValueProvider(appName, missionTypeEntityName, 'Mission Type', false, missionTypeEntityName, (client) => {
            var _a;
            const authorizedMissionTypeIds = (_a = userState === null || userState === void 0 ? void 0 : userState.authorizedMissionTypeIds) !== null && _a !== void 0 ? _a : [];
            return client
                .storageList({
                filter: [{ column: 'status', op: '=', value: 'active' }],
                orderBy: [{ column: 'name' }],
            })
                .then((result) => {
                return result.rows.reduce((missionTypeValues, missionType) => {
                    if (requireAnySystemPermission(userState, 'manage-missions') || authorizedMissionTypeIds.includes(missionType.id)) {
                        missionTypeValues.push({
                            label: missionType.columns.name,
                            value: missionType.id,
                        });
                    }
                    return missionTypeValues;
                }, []);
            });
        }),
        buildValueProvider(appName, missionPositionEntityName, 'Mission Position', false),
        buildStorageValueProvider({
            entityName: occupationEntityName,
            label: 'Occupations By Group Ids',
            classifierName: 'occupationsByGroupIds',
            getValues: (client, params) => __awaiter(this, void 0, void 0, function* () {
                const parsedParams = occupationsByGroupIdsParamsSchema.safeParse(params);
                if (parsedParams.error)
                    return [];
                const occupations = yield client.list({
                    filter: [
                        {
                            column: 'groupId',
                            op: 'in',
                            value: parsedParams.data,
                        },
                        {
                            column: 'status',
                            op: '=',
                            value: 'active',
                        },
                    ],
                });
                return occupations.rows.map(({ columns, id }) => ({ label: columns.name, value: id }));
            }),
        }),
    ];
}
